module.exports = "/images/Icon industry-QuestRoom.svg?703e35c77aec16de96e10d9059581318";